/** Crystal Bardawam — this web app only uses this service. */
export const APP_SERVICE_ID = 1;

export function withServiceQuery(path) {
  const base = String(path ?? '');
  const separator = base.includes('?') ? '&' : '?';
  return `${base}${separator}service_id=${APP_SERVICE_ID}`;
}

export function isAppServiceItem(item) {
  if (item == null || item.service_id == null) return true;
  return Number(item.service_id) === APP_SERVICE_ID;
}
